import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EdlCommonModalService, SessionService, User } from '@edl-development/edl-common';
import { ToastrService } from 'ngx-toastr';
import { firstValueFrom } from 'rxjs';
import { EdlComment } from 'src/app/model/comment.model';
import { CommentState } from 'src/app/model/enum/comment-state.enum';
import { FileAttachment } from 'src/app/model/attachment/file-attachment.model';
import { ObservationSummaryDTO } from 'src/app/model/observation/observation-summary-dto.model';
import { CommentService } from 'src/app/services/comment.service';
import { ObservationCommentService } from '../../services/observation-comment/observation-comment.service';
import { FileService } from 'src/app/services/file.service';
import { CommentTags } from '../../enums/comment-tags.enum';

@Component({
    selector: 'app-observation-comment-cell',
    templateUrl: './observation-comment-cell.component.html',
    styleUrls: ['./observation-comment-cell.component.scss']
})
export class ObservationCommentCellComponent implements OnInit {
    @Input() comment?: EdlComment;
    @Input() observationType: any;
    @Input() observationSummary?: ObservationSummaryDTO;
    @Input() hideFilter: boolean = false;
    @Input() evalUser?: User | null;
    @Input() defaultLookupValue?: string;
    @Input() isEditMode: boolean = false;
    @Input() isReadOnly: boolean = false;
    @Input() attachmentLabel: string = "";
    @Output() commentChange = new EventEmitter<EdlComment>();
    @Output() isEditModeChange = new EventEmitter<boolean>();

    CommentState = CommentState;
    CommentTags = CommentTags;
    isMyComment: boolean = false;

    constructor(
        private edlCommonModalService: EdlCommonModalService,
        private observationCommentService: ObservationCommentService,
        private commentService: CommentService,
        private sessionService: SessionService,
        private toastr: ToastrService,
        private fileService: FileService
    ) { }

    ngOnInit(): void {
        this.isMyComment = this.sessionService.user?.UserID === this.comment?.userId;
    }

    addComment() {
        this.setIsEditMode(true);
    }

    openComment(comment: EdlComment) {
        if (comment.userId == this.evalUser?.UserID) {
            this.setIsEditMode(true);
        }
    }

    private setIsEditMode(value: boolean) {
        this.isEditMode = value;
        this.isEditModeChange.emit(this.isEditMode);
    }

    getHeaderStyles = () => this.isMyComment ? { '--paetep-display-comment-header-bg-color': '#ddd' } : {};

    deleteComment(comment: EdlComment) {
        this.edlCommonModalService.confirm('Confirmation', 'Are you sure you want to delete this comment?')
            .then(() => {
                firstValueFrom(
                    this.commentService
                        .deleteComment(comment)
                ).then(() => {
                    this.refreshCommentList();
                    this.observationCommentService.onAttachmentChange(comment);
                    this.toastr.success("Comment deleted.")
                }).catch(error => {
                    this.toastr.error(error);
                });
            });
    }

    publishComment(comment: EdlComment) {
        if (comment.commentState == CommentState.DRAFT) comment.commentState = CommentState.PUBLISHED; //this depends on the state of the observatio, no? Might need to move this into the backend
        this.observationCommentService.saveComment(comment)
            .then((result: EdlComment | null | undefined) => {
                if (result) {
                    this.setComment(result);
                    this.refreshCommentList();
                    this.toastr.success("Comment published successfully.");
                } else {
                    this.toastr.error('Comment failed to be published.');
                }
            }).catch(error => {
                this.toastr.error(error);
            });
    }

    refreshCommentList() {
        this.observationCommentService.reloadComments();
    }

    onClose() {
        this.setIsEditMode(false);
        this.refreshCommentList();
    }

    setComment(modifiedComment: EdlComment) {
        this.comment = modifiedComment;
        this.commentChange.emit(this.comment);
    }

    onAttachmentDeleted(attachment: FileAttachment) {
        const index = this.comment?.attachments.indexOf(attachment, 0);
        if (index! > -1) {
            this.comment?.attachments.splice(index!, 1);
        }

        this.observationCommentService.onAttachmentChange(this.comment!);
    }
}
